"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserIPAddress = void 0;
/* --------------- UTILITIES : APIs : USER IP --------------- */

var getUserIPAddress = function getUserIPAddress() {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://api.ipify.org?format=json', true);

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response);
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      }
    };

    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText
      });
    };

    xhr.send(null);
  });
};

exports.getUserIPAddress = getUserIPAddress;